<template>
  <div class="body">
    <section class="ticket-popup-wrap">
      <h1 class="popup-header" tabindex="1">웨이브 상품 구매</h1>
        <!-- 이용권 리스트 출력 -->
      <div v-if="!isLoading && isEmptyList" class="my-pay-empty">
        <empty-list text="구매 가능한 상품이 없어요."></empty-list>
      </div>
      <template v-if="!isLoading && dataList">
          <popup-product-category v-for="(data, index) in dataList"
                                  :key="index"
                                  :category="data"
                                  :content-id="contentid"
                                  :content-type="contenttype"
                                  :package-detail-map="packageDetailMap"/>

        <div class="popup-noti">
          <p class="dot-text"><span>Wavve 서비스는 국내 및 해외 일부 해외 서비스 대상 국가에서 이용하실 수 있습니다. </span></p>
          <p class="dot-text"><span>국내에서 결제완료된 콘텐츠에 한해 해외 서비스 대상국가 여행 시 모바일 앱(ios/Android)으로 7일간 스트리밍(재생) 서비스를 이용하실 수 있습니다.</span></p>
          <p class="dot-text"><span>해외 서비스 대상국가 : 싱가폴, 인도네시아, 말레이시아, 필리핀, 베트남, 라오스, 태국</span></p>
          <p class="dot-text"><span>해외 서비스 대상국가가 아닌 지역에서는 서비스 이용이 불가하며, 일부 콘텐츠는 콘텐츠제공사(CP)의 별도 요청, 저작권 문제, 기타 사업권역 문제 등으로 해외 서비스 이용이 제한될 수 있습니다.</span></p>
          <p class="dot-text"><span>동시시청은 계정당 허용 가능한 회선만큼 동시에 여러 기기에서 시청하실 수 있는 상품입니다. 1회선인 경우 동시시청을 할 수 없습니다.</span></p>
          <p class="dot-text"><span>일부 콘텐츠는 저작권자의 요청에 따라 LIVE 및 VOD 서비스가 제공되지 않을 수 있습니다.</span></p>
          <p class="dot-text"><span>일부 콘텐츠는 콘텐츠 제공사의 사정에 따라 FHD화질이 제공되지 않을 수 있습니다.</span></p>
          <p class="dot-text"><span>방송VOD 다운로드는 콘텐츠에 따라 다운로드가 제한될 수 있으며, 서비스 사정에 따라 다운로드 횟수가제한될 수 있습니다.</span></p>
          <p class="dot-text"><span>방송VOD 다운로드는 PC, TV에서는 제공하지 않습니다.</span></p>
          <p class="dot-text"><span>자동결제 시 이용기간 중 결제 당일을 제외하고 언제든지 자동결제를 해지하실 수 있습니다.</span></p>
          <p class="dot-text"><span>FHD 이용권 구매 시 시범 서비스 기간동안 TV기기 (스마트TV 및 안드로이드 STB App)에서 일부 콘텐츠를 UHD로 이용하실 수 있습니다.</span></p>
          <p class="dot-text"><span>기타 자세한 사항은 이용권 안내 페이지를 참고해 주세요.</span></p>
          <p class="dot-text"><span class="noti-more" style="display: inline;">이용권 구매 후 7일이 경과 되었거나 이용권을 사용한 경우 웨이브 고객센터를 통해 환불 절차를 문의해주시기 바랍니다.</span></p>
          <p class="dot-text"><span class="noti-more" style="display: inline;">이용권 구매 후 환불을 원하시면 웨이브 고객센터에 연락해 주시기 바랍니다.</span></p>

          <div style="margin-top: 1.2rem;">
            <p v-if="!guideDetailToggle">
              <!-- <span class="noti-more" style="display: inline;">이용권 구매 후 7일이 경과 되었거나 이용권을 사용한 경우 웨이브 고객센터를 통해 환불 절차를 문의해주시기 바랍니다.</span> -->
              <span @click="detailToggle()" class="detail-info detail-info-open" style="border-bottom: none; margin: 0;">자세히보기</span>
            </p>
            <p v-else>
              <!-- <span>이용권 구매 후 7일이 경과 되었거나 이용권을 사용한 경우 웨이브 고객센터를 통해 환불 절차를 문의해주시기 바랍니다.</span> -->
              <span @click="detailToggle()" class="detail-info detail-info-close" style="border-bottom: none; margin: 0;">닫기</span>
            </p>
          </div>
         <div v-if="guideDetailToggle" class="detail-info-content">
            <p class="dot-text">
              <span>회원이 유료결제 후 사용하지 않은 상품은 구매일 기준 7일 내 청약 철회가 가능합니다.</span>
            </p>
            <p class="dot-text">
              <span>고객센터>1:1문의하기 메뉴를 통해 청약철회 의사를 표시할 수 있으며, 접수일로부터 3영업일 이내 결제 취소 또는 현금 환불해 드립니다. 다만, 각 호의 경우에는 결제취소처리가 불가능합니 다.<br/>
              ① 이벤트, 쿠폰, 보상 등 결제수단이 무료로 지급된 경우<br/>
              ② 해당 기간 내에 사용내역이 있을 경우<br/>
              ③ 해당 결제수단에 따른 결제취소 가능기간을 경과한 경우
              </span>
            </p>
            <p class="dot-text">
              <span>만 20세 미만의 미성년자의 유료서비스 이용은 법정대리인이 이를 취소할 수 있습니다. (단, 결제 수단의 명의자가 성년인 경우에는 취소 제한)</span>
            </p>
          </div>
          <p class="dot-text"><span>12개월 이용권 할인 프로모션(12개월 이용권 33% 할인)은 2024.04.01 10:30 부터 2024.04.14 23:59까지 진행됩니다.</span></p>
          <p class="dot-text"><span>12개월 이용권 할인 프로모션 기간에 할인 상품 구매 시 첫 해에만 추가 할인 금액으로 결제되고, 12개월 후에는 기존 금액 (16% 할인)으로 연 1회 정기 결제됩니다.</span></p>
          <!-- <p class="dot-text"><span class="noti-more" style="display: inline;">이용권 구매 후 7일이 경과 되었거나 이용권을 사용한 경우 웨이브 고객센터를 통해 환불 절차를 문의해주시기 바랍니다.</span></p>
          <p class="dot-text"><span class="noti-more" style="display: inline;">이용권 구매 후 환불을 원하시면 웨이브 고객센터에 연락해 주시기 바랍니다.</span></p> -->
        </div>
      </template>
    </section>
  </div>
</template>

<script>
import axios from 'axios'
import { parseUrl } from 'query-string'
import PopupProductCategory from '@/components/voucher/PopupProductCategory'
import { getPurchaseProductContents, getPurchaseProducts } from '@/common/utils/request'
import _ from 'lodash'
import { setNumberCommas } from '@/common/utils/common'
import EmptyList from '@/components/mypooq/EmptyList'

export default {
  components: {
    PopupProductCategory,
    EmptyList
  },
  data () {
    return {
      type: 'voucher',
      cpid: '',
      channelid: '',
      programid: '',
      contentid: '',
      contenttype: '',
      playy: 'n',
      downloadyn: 'n',
      dataList: [],
      packageDetailMap: {},
      currentProductName: '',
      currentDescription: '',
      currentPrice: '',
      concurrencyCount: 1,
      currentProduct: {},
      passgroup_type: '',
      currentIndex: 'group_5_0',
      currentProductType: '',
      guideDetailToggle: false,
      isEmptyList: false,
      isLoading: true
    }
  },
  methods: {
    detailToggle () {
      this.guideDetailToggle = !this.guideDetailToggle
    },
    async setData () {
      this.isLoading = true
      let voucherType = this.type === 'movie' ? 'all' : this.type
      const { data } = await getPurchaseProducts({ cpid: this.cpid, channelid: this.channelid, programid: this.programid, contentid: this.contentid, contenttype: this.contenttype, vouchertype: voucherType, isplayy: this.playy, downloadyn: this.downloadyn })
      this.converter(data)
      const emptyList = this.dataList.filter((voucherInfo, index) => {
        return Number(_.get(voucherInfo, 'productgroups_count', '0')) === 0
      })
      this.isEmptyList = emptyList.length === this.dataList.length
      this.setPackageMap(this.dataList)
      this.isLoading = false
    },
    setPackageMap (voucherList) {
      const packageList = voucherList.filter((group) => {
        const groupType = _.get(group, 'passgroup_type', null)
        const productCount = _.get(group, 'productgroups_count', 0)
        return groupType === 'package' && productCount > 0
      })
      const packageIdList = packageList.map((voucher) => {
        return _.get(voucher, 'productgroups.0.products.0.concurrency.0.productid', null)
      })
      axios.all(packageIdList.map((id) => {
        return getPurchaseProductContents({ productid: id, contenttype: this.contentType })
      })).then((responseList) => {
        this.packageDetailMap = responseList.reduce((acc, cur) => {
          const { url } = parseUrl(cur.request.responseURL)
          const lastPath = url.split('/').pop()
          acc[lastPath] = _.get(cur, 'data.0.list', [])
          return acc
        }, {})
      })
    },
    converter (data) {
      let newProductsArr = []
      this.dataList = data.map((voucherData) => {
        if (voucherData.passgroup_type === 'voucher') {
          voucherData.productgroups.map((productgroups) => {
            if (productgroups.productgroup_name === 'wavve 팩') {
              productgroups.products.map((product) => {
                if (product.concurrency.length > 1) {
                  product.concurrency.map((voucher) => {
                    newProductsArr.push({
                      orderno: product.orderno,
                      screen_name: product.screen_name,
                      quality_name: product.quality_name,
                      concurrency_count: product.concurrency_count,
                      concurrency: [voucher]
                    })
                    productgroups.products = newProductsArr
                    return voucher
                  })
                } else {
                  newProductsArr.push(product)
                }
              })
            }
            return productgroups
          })
        }
        return voucherData
      })
    },
    initialize () {
      this.dataList = []
      this.type = _.get(this.$route, ['query', 'type'], 'voucher')
      this.cpid = _.get(this.$route, ['query', 'cpid'], '')
      this.channelid = _.get(this.$route, ['query', 'channelid'], '')
      this.programid = _.get(this.$route, ['query', 'programid'], '')
      this.contentid = _.get(this.$route, ['query', 'contentid'], '')
      this.contenttype = _.get(this.$route, ['query', 'contenttype'], '')
      this.playy = _.get(this.$route, ['query', 'playy'], 'n')
      this.downloadyn = _.get(this.$route, ['query', 'downloadyn'], 'n')
    },
    setNumberCommas (price) {
      return setNumberCommas(price)
    }
  },
  created () {
    this.initialize()
    this.setData()
  },
  watch: {
    type () {
      this.initialize()
      this.setData()
    }
  }
}
</script>
<style lang="scss" src="@/assets/scss/category/ticket.scss"></style>
<style scoped>
  .sticky{
    position: fixed;
    bottom: 0;
    background-color: black;
    width: 100%;
    height: 50px;
  }
  .sticky span {
    color: white
  }
  .detail-info {
    width: auto;
    padding-right: 17px;
    margin: 10px 0 4px 10px;
    color: #a5a5a5;
    border-bottom: 1px solid #a5a5a5;
    cursor: pointer;
  }
  .detail-info-open,
  .detail-info-close {
    background-size: 16px auto;
    background-repeat: no-repeat;
    background-position: right center;
  }
  .detail-info-open{
    background-image: url(../../assets/images/ticket/element-icons-40-x-40-all-dropdown-arrow.svg);

  }
  .detail-info-close{
    background-image: url(../../assets/images/ticket/element-icons-40-x-40-all-dropup-arrow.svg);
  }
  /*.detail-info-content{*/
  /*  padding-top: 15px;*/
  /*  padding-left: 12px;*/
  /*}*/
  /*.detail-info-content p{*/
  /*  margin-bottom: 5px;*/
  /*}*/
  /*.detail-info-content p:before{*/
  /*  display: inline-block;*/
  /*  vertical-align: top;*/
  /*  content: '-';*/
  /*  margin-right: 6px;*/
  /*}*/
  /*.detail-info-content span{*/
  /*  display: inline-block;*/
  /*  width: calc(100% - 12px);*/
  /*}*/
</style>
